import { Component, Output, EventEmitter, Input, OnInit, AfterViewInit } from '@angular/core';
import { Globals } from '../../../globals';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { URLDialog } from '../URLDialog/URLDialog';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageViewerDialog } from '../ImageViewerDialog/ImageViewerDialog';
import { AuthService } from 'src/app/API/auth.service';
import { InvApiService } from 'src/app/API/invapi.service';

@Component({
  selector: 'attachment',
  templateUrl: './AttachmentComponent.html'
})
export class AttachmentComponent implements OnInit, AfterViewInit {
  public PrevAttachments = [];
  public DocId;
  public UploadBy;
  public moduleName = '';
  urlDialogRef: MatDialogRef<URLDialog>;
  extension: string;
  @Output()
  RaiseError = new EventEmitter();
  zoomMode="click";
  public uploadID = 'ng2Fileuploader';
  loggedInUserDesignation = this.auth.GetDesignationName();
  @Input() category: string = '';


  public uploader: FileUploader = new FileUploader({
    url: '',
    autoUpload: true,
    method: 'POST',
    allowedFileType: ['image', 'doc', 'ppt', 'pdf', 'xls'],
    maxFileSize: 20 * 1024 * 1024
  });

  AddFileToQueue(files : File[]){
    this.uploader.addToQueue(files);
  }

  RemovePrevAttachments(fileItem){
    this.PrevAttachments.splice(this.PrevAttachments.indexOf(fileItem), 1);
  }

  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = item => {
      item.withCredentials = false;

    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any
    ) => {
      var json = JSON.parse(response);
      item.index = json.uploadfilename;
    };
    this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);

  }
  constructor(public dialog: MatDialog,private auth :AuthService, private invapi: InvApiService) {}

  ngOnInit() {
    const uploadCategory = this.category || 'default';
    this.uploader.setOptions({
      url: Globals.apiUrl +
        `Files/Upload?containerName=uploads&category=${uploadCategory}`
    });
    this.uploader.autoUpload = true;
  }

  //file upload
  public clearQueue() {
    this.uploader.clearQueue();
  }

  public Queue() {
    return this.uploader.queue;
  }

  public SetQueue(Queue) {
    this.uploader.queue = Queue;
  }

  UploadFiles() {
    document.getElementById(this.uploadID).click();
  }

  SetAttachmentUrl(fileName) {
    return Globals.AttachmentUrl + '/' + fileName;
  }

  OpenFile(FileName, URL) {
    this.invapi.GetSasUrl('uploads', FileName).subscribe(response => {
      this.urlDialogRef = this.dialog.open(URLDialog, {
      disableClose: true,
      position: { right: '0', top: '0' },
      height: '100%',
    });
    this.urlDialogRef.componentInstance.URL = response.toString();
    this.urlDialogRef.componentInstance.dialogRef.updateSize('80%', '80%');
    this.urlDialogRef.componentInstance.PageTitle = FileName;
    this.urlDialogRef.afterClosed().subscribe(result => {
      this.urlDialogRef = null;
    });
    }, error => {
      console.error('Failed to fetch SAS URL for', FileName, error);
    });
    
  }
openImageDialog(FileName, URL): void {
  this.invapi.GetSasUrl('uploads', this.category + '/' +FileName).subscribe(response => {
    const sasUrl = response.url; // This is the signed blob URL from API
    this.extension = FileName.split('.').pop()?.toLowerCase();

    if (['png', 'jpg', 'gif', 'jpeg'].includes(this.extension)) {
      const dialogRef = this.dialog.open(ImageViewerDialog, {
        position: { right: '0', top: '0' },
        height: '100%',
        width: '70%',
        data: { imgURL: sasUrl, title: FileName }
      });

      dialogRef.afterClosed().subscribe(() => {
        this.urlDialogRef = null;
      });
    } else {
      this.urlDialogRef = this.dialog.open(URLDialog, {
        disableClose: true,
        position: { right: '0', top: '0' },
        height: '100%',
      });

      this.urlDialogRef.componentInstance.URL = sasUrl; // use SAS URL here too
      this.urlDialogRef.componentInstance.dialogRef.updateSize('80%', '100%');
      this.urlDialogRef.componentInstance.PageTitle = FileName;
      this.urlDialogRef.afterClosed().subscribe(() => {
        this.urlDialogRef = null;
      });
    }
  }, error => {
    console.error('Failed to fetch SAS URL for', FileName, error);
  });
}

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    var errorMessage;
    switch (filter.name) {
        case 'fileSize':
            errorMessage = `Maximum upload size exceeded (${Math.round((item.size/1024/1024))} MB of 20 MB allowed)`;
            break;
        case 'mimeType':
            errorMessage = `Type '${item.type} is not allowed. Allowed types: '(JPG, GIF, PNG, DOC, XLS, PPT, PDF, JPEG)'`;
            break;
        default:
            errorMessage = `Type '${item.type} is not allowed. Allowed types: '(JPG, GIF, PNG, DOC, XLS, PPT, PDF, JPEG)'`;
    }
      this.RaiseError.emit(errorMessage);

}
  
  public GenerateAttachmentList() {
    var finalAttachmentList = [];
    for (let childObj in this.PrevAttachments) {
      var pobj = {
        attachmentId: this.PrevAttachments[childObj].attachmentId,
        Id: this.DocId,
        attachmentPath: this.PrevAttachments[childObj].attachmentpath,
        attachmentName: this.PrevAttachments[childObj].attachmentname,
        uploadedBy: this.PrevAttachments[childObj].uploadedby,
        uploadedOn: this.PrevAttachments[childObj].uploadedon,
        moduleName: this.PrevAttachments[childObj].modulename
      };
      finalAttachmentList.push(pobj);
    }
    for (let childObj in this.uploader.queue) {
      var obj = {
        attachmentId: 0,
        Id: this.DocId,
        attachmentPath: this.uploader.queue[childObj].index,
        attachmentName: this.uploader.queue[childObj].file.name,
        uploadedBy: this.UploadBy,
        uploadedOn: new Date(),
        moduleName: this.moduleName
      };
      finalAttachmentList.push(obj);
    }

    return finalAttachmentList;
  }
}
